<template>
  <div class="owner-directory">
    <el-card class="section-card search-card" shadow="never">
      <div class="search-head">
        <div>
          <p class="eyebrow">Owner Directory</p>
          <h2>{{ title }}</h2>
          <p class="subcopy">{{ description }}</p>
        </div>
        <el-input
          v-model.trim="search"
          class="search-input"
          clearable
          :placeholder="searchPlaceholder"
        />
      </div>
    </el-card>

    <el-card class="section-card table-card" shadow="never">
      <el-table
        :data="filteredRows"
        v-loading="loading"
        empty-text="No records to show."
        height="520"
        class="users-table"
        header-cell-class-name="users-table__header"
      >
        <el-table-column label="Name" min-width="180">
          <template #default="scope">
            <strong class="name-cell">{{ scope.row.name || 'Not provided' }}</strong>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="Email" min-width="220" />
        <el-table-column prop="role" label="Role" min-width="120" align="center" />
        <el-table-column label="Portal Status" min-width="160" align="center">
          <template #default="scope">
            {{ scope.row.employeePortal?.status || 'Not started' }}
          </template>
        </el-table-column>
        <el-table-column label="Updated" min-width="190" align="center">
          <template #default="scope">
            {{ formatDate(scope.row.updatedAt) || 'Not available' }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { watchUsersByRole } from '@/services/owner'

export default {
  name: 'OwnerDirectoryPanel',
  props: {
    role: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    searchPlaceholder: {
      type: String,
      default: 'Search by name or email',
    },
  },
  data() {
    return {
      search: '',
      loading: true,
      rows: [],
      unsub: null,
    }
  },
  computed: {
    filteredRows() {
      const term = this.search.trim().toLowerCase()
      if (!term) return this.rows
      return this.rows.filter((row) => {
        const haystack = [
          row.name,
          row.email,
          row.uid,
        ].filter(Boolean).join(' ').toLowerCase()
        return haystack.includes(term)
      })
    },
  },
  watch: {
    role: 'subscribe',
  },
  mounted() {
    this.subscribe()
  },
  beforeUnmount() {
    this.unsub && this.unsub()
  },
  methods: {
    subscribe() {
      this.unsub && this.unsub()
      this.loading = true
      this.unsub = watchUsersByRole(this.role, (rows) => {
        this.rows = rows
        this.loading = false
      })
    },
    formatDate(ts) {
      if (!ts) return ''
      try {
        const ms = ts.toMillis ? ts.toMillis() : (ts.seconds || 0) * 1000
        return new Date(ms).toLocaleString()
      } catch {
        return ''
      }
    },
  },
}
</script>

<style scoped>
.owner-directory {
  display: grid;
  gap: 16px;
}

.search-card,
.table-card {
  border-radius: 22px;
}

.search-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.search-input {
  width: min(360px, 100%);
}

.eyebrow {
  margin: 0 0 6px;
  color: #0b6cff;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

h2 {
  margin: 0 0 6px;
  color: #03241f;
  font-size: 1.5rem;
  font-weight: 850;
}

.subcopy {
  margin: 0;
  color: #4f6d67;
}

.users-table__header {
  background: #003831;
  color: #ffffff;
  font-weight: 800;
  text-align: center;
}

:deep(.el-table__header th.users-table__header) {
  background: #003831 !important;
  color: #ffffff !important;
  text-align: center;
}

.name-cell {
  color: #03241f;
}

@media (max-width: 860px) {
  .search-head {
    flex-direction: column;
  }

  .search-input {
    width: 100%;
  }
}
</style>
